import React from "react";
import GoTop from "./GoTop"

if (typeof window !== "undefined") {
    // eslint-disable-next-line global-require
    require("smooth-scroll")('a[href*="#"]')
  }

const Layout = ({ children }) => {
    return (
        <>
         
            {children}
          
            <GoTop />
        </>
    )

}

export default Layout
